import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import classnames from 'classnames';
import Icon, { GLYPHS } from '../../../common/icon';
import Dropdown from '../../../common/Dropdown';
import { canUserViewAppointmentContactInfo } from '../../../common/helpers/users';
import { maskEmail, maskPhoneNumber } from '../../../common/helpers/mask';

const CustomerSelect = ({
  value,
  selectCustomer,
  unselectCustomer,
  selectedCustomer,
  results,
  onBlur,
  square,
  permissions,
  fetchResults,
  setValue,
}) => {
  const canViewContactInfo = canUserViewAppointmentContactInfo(permissions);

  const fetchSearchResults = useMemo(() => debounce(fetchResults, 300), []);
  const onChange = (e) => {
    setValue(e.target.value);
    fetchSearchResults(e.target.value);
  };

  return (
    <div className="u-position-relative">
      <input
        className={classnames('c-input c-input--white u-height-40', { 'c-input--border': square })}
        placeholder="Choose Client"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={selectedCustomer}
      />
      <Dropdown width="100%">
        {results.map((hit, idx) => (
          <Dropdown.Item key={hit.id || idx}>
            <button
              className={classnames('c-btn c-btn--blank u-p- u-1/1 u-text-left', { 'c-btn--no-radius': square })}
              type="button"
              onMouseDown={selectCustomer(hit.document)}
            >
              <div className="u-text-trim u-type--normal u-type--no-transform delta">
                <span className="u-mr-">{hit.document.name}</span>
                <span className="u-mr-">
                  {!canViewContactInfo ? maskPhoneNumber(hit.document.phone) : hit.document.phone}
                </span>
                <span>
                  {!canViewContactInfo ? maskEmail(hit.document.email) : hit.document.email}
                </span>
              </div>
            </button>
          </Dropdown.Item>
        ))}
      </Dropdown>
      <button
        type="button"
        className="c-btn c-btn--blank u-inline-block u-pin-right u-mr-"
        onClick={unselectCustomer}
        display-if={selectedCustomer}
      >
        <Icon glyph={GLYPHS.arrowXClose} />
      </button>
    </div>
  );
};
CustomerSelect.propTypes = {
  results: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  selectCustomer: PropTypes.func.isRequired,
  unselectCustomer: PropTypes.func.isRequired,
  selectedCustomer: PropTypes.string,
  square: PropTypes.bool,
  permissions: PropTypes.object.isRequired,
  fetchResults: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
};
CustomerSelect.defaultProps = {
  selectedCustomer: '',
  results: [],
  square: false,
};

export default CustomerSelect;
